import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/apps/wisprs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocsAiToolbar"] */ "/opt/apps/wisprs/src/components/developer/docs-ai-toolbar.tsx");
